import React from 'react';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  Timeline,
  TimelineItem,
  TimelineDate,
  TimelineTitle,
  TimelineDescription,
} from './styles';

const TrajectorySection = () => {
  return (
    <ProfileCard>
      <CardTitle>Trayectoria Política</CardTitle>
      <CardContent>
        <Timeline>
          <TimelineItem>
            <TimelineDate>Diciembre 2025 — Presente</TimelineDate>
            <TimelineTitle>Concejal · Honorable Concejo Deliberante</TimelineTitle>
            <TimelineDescription>
              Asume su banca por La Libertad Avanza tras las legislativas de
              octubre 2025. Mandato 2025–2029.
            </TimelineDescription>
          </TimelineItem>
          <TimelineItem>
            <TimelineDate>Octubre 2025</TimelineDate>
            <TimelineTitle>Elecciones legislativas · LLA San Nicolás</TimelineTitle>
            <TimelineDescription>
              Encabeza la lista de concejales por La Libertad Avanza con apoyo
              estratégico de Primero San Nicolás.
            </TimelineDescription>
          </TimelineItem>
          <TimelineItem>
            <TimelineDate>Junio 2025</TimelineDate>
            <TimelineTitle>Alianza con La Libertad Avanza</TimelineTitle>
            <TimelineDescription>
              Acuerdo entre Primero San Nicolás y LLA para unificar la oferta
              electoral local.
            </TimelineDescription>
          </TimelineItem>
          <TimelineItem>
            <TimelineDate>2023</TimelineDate>
            <TimelineTitle>Candidato a 1º Concejal · Primero San Nicolás</TimelineTitle>
            <TimelineDescription>
              Obtuvo 4,041 votos (4.5% del total) en una elección dominada por
              JxC y UxP.
            </TimelineDescription>
          </TimelineItem>
          <TimelineItem>
            <TimelineDate>2019 — Presente</TimelineDate>
            <TimelineTitle>Director Titular · MoviPort S.A.</TimelineTitle>
            <TimelineDescription>
              Empresa logística especializada en servicios portuarios sobre el
              río Paraná.
            </TimelineDescription>
          </TimelineItem>
          <TimelineItem>
            <TimelineDate>2019 — Presente</TimelineDate>
            <TimelineTitle>Presidente · Fundación MoviPort</TimelineTitle>
            <TimelineDescription>
              Entidad de la sociedad civil con sede en San Nicolás, enfocada en
              educación técnica y desarrollo local.
            </TimelineDescription>
          </TimelineItem>
        </Timeline>
      </CardContent>
    </ProfileCard>
  );
};

export default TrajectorySection;
